import { render, staticRenderFns } from "./BlockBoxedContent.vue?vue&type=template&id=aa87a032&"
import script from "./BlockBoxedContent.vue?vue&type=script&lang=js&"
export * from "./BlockBoxedContent.vue?vue&type=script&lang=js&"
import style0 from "./BlockBoxedContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports